:export {
  --c-off-white: var(--c-off-white);
  --c-goma-grey: var(--c-goma-grey);
  --c-white: var(--c-white);
  --c-mid-grey: var(--c-mid-grey);
  --c-map-blue: var(--c-map-blue);
  --c-goma-grey-hover: var(--c-goma-grey-hover);
  --c-goma-grey-selected: var(--c-goma-grey-selected);
  --c-goma-grey-disabled: var(--c-goma-grey-disabled);
  --g-gap: var(--g-gap);
  --g-col-size: var(--g-col-size);
  --container-width: var(--container-width);
  --slope: var(--slope);

  map-primary: #65677f;
  map-outline: #51536f;
  map-fill: #ffffff;
  map-terrain: #569972;
  map-water: #a4cae1;
  map-gallery: #db519b;
  map-venue: #64acd6;
}
